import { GroupBase, StylesConfig } from 'react-select';

type OptionType = {
  value: string;
  label: string;
};

export const customStyles: StylesConfig<OptionType, boolean, GroupBase<OptionType>> = {
  control: (provided) => ({
    ...provided,
    cursor: 'text',
    margin: '15px 0 20px 0',
    padding: '10px 0 5px 0',
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 100,
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: '#343a40',
    color: '#F94772',
    borderRadius: '5px',
  }),
  valueContainer: (provided) => ({
    ...provided,
    overflowY: 'scroll',
    maxHeight: '40px',
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: '#ffffff',
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    cursor: 'pointer',
    transition: '0.3s',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    display: 'none',
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    display: 'none',
  }),
  clearIndicator: (provided) => ({
    ...provided,
    cursor: 'pointer',
    transition: '0.3s',
    ':hover': {
      color: '#F94772',
    },
  }),
};
